import React from "react";

export type CamerasEmptyPanelVariant = "cameras" | "liveView";

export type CamerasEmptyPanelProps = {
  variant: CamerasEmptyPanelVariant;
  /** `empty` = no cameras; `error` = list API failed */
  reason: "empty" | "error";
  isAdmin?: boolean;
  onAddCamera?: () => void;
  onRetry?: () => void;
  /** Extra detail when `reason` is `error` (e.g. API message) */
  errorDetail?: string | null;
};

/**
 * Centered empty / error state for Cameras and Live View (Omni Watch layout).
 */
export function CamerasEmptyPanel({
  variant,
  reason,
  isAdmin = false,
  onAddCamera,
  onRetry,
  errorDetail,
}: CamerasEmptyPanelProps) {
  const isCameras = variant === "cameras";

  const title =
    reason === "error" ? "Unable to load cameras" : "No cameras yet";

  let subtitle: string;
  if (reason === "error") {
    const detail = errorDetail?.trim();
    subtitle = detail
      ? detail
      : "Check your connection and API configuration, then try again.";
  } else if (isCameras) {
    subtitle = isAdmin
      ? "Get started by adding your first camera."
      : "No camera assigned. Ask an admin for access.";
  } else {
    subtitle =
      "Add a camera on the Cameras tab to see preview targets here.";
  }

  return (
    <div className="ds-cam-empty-panel" role="status">
      <p className="ds-cam-empty-panel__title">{title}</p>
      <p className="ds-cam-empty-panel__subtitle">{subtitle}</p>
      <div className="ds-cam-empty-panel__actions">
        {reason === "error" && onRetry ? (
          <button
            type="button"
            className="ds-btn ds-btn--primary"
            onClick={onRetry}
          >
            Retry
          </button>
        ) : null}
        {reason === "empty" && isCameras && isAdmin && onAddCamera ? (
          <button
            type="button"
            className="ds-btn ds-btn--primary"
            onClick={onAddCamera}
          >
            Add Camera
          </button>
        ) : null}
      </div>
    </div>
  );
}
